// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c5c55b8","239":"ef3fadeb","455":"3920bd22"}[chunkId] + ".chunk.js";
};